export const MAP_SPECIAL = ['北京', '天津', '上海', '重庆', '香港', '澳门']

export const MAP_CITY = {
  北京市: '110100000',
  天津市: '120100000',
  上海市: '310100000',
  重庆市: '500100000',

  崇明县: '310200000',
  湖北省直辖县市: '429000000',
  铜仁市: '522200000',
  毕节市: '522400000',

  石家庄市: '130100000',
  唐山市: '130200000',
  秦皇岛市: '130300000',
  邯郸市: '130400000',
  邢台市: '130500000',
  保定市: '130600000',
  张家口市: '130700000',
  承德市: '130800000',
  沧州市: '130900000',
  廊坊市: '131000000',
  衡水市: '131100000',
  太原市: '140100000',
  大同市: '140200000',
  阳泉市: '140300000',
  长治市: '140400000',
  晋城市: '140500000',
  朔州市: '140600000',
  晋中市: '140700000',
  运城市: '140800000',
  忻州市: '140900000',
  临汾市: '141000000',
  吕梁市: '141100000',
  呼和浩特市: '150100000',
  包头市: '150200000',
  乌海市: '150300000',
  赤峰市: '150400000',
  通辽市: '150500000',
  鄂尔多斯市: '150600000',
  呼伦贝尔市: '150700000',
  巴彦淖尔市: '150800000',
  乌兰察布市: '150900000',
  兴安盟: '152200000',
  锡林郭勒盟: '152500000',
  阿拉善盟: '152900000',
  沈阳市: '210100000',
  大连市: '210200000',
  鞍山市: '210300000',
  抚顺市: '210400000',
  本溪市: '210500000',
  丹东市: '210600000',
  锦州市: '210700000',
  营口市: '210800000',
  阜新市: '210900000',
  辽阳市: '211000000',
  盘锦市: '211100000',
  铁岭市: '211200000',
  朝阳市: '211300000',
  葫芦岛市: '211400000',
  长春市: '220100000',
  吉林市: '220200000',
  四平市: '220300000',
  辽源市: '220400000',
  通化市: '220500000',
  白山市: '220600000',
  松原市: '220700000',
  白城市: '220800000',
  延边朝鲜族自治州: '222400000',
  哈尔滨市: '230100000',
  齐齐哈尔市: '230200000',
  鸡西市: '230300000',
  鹤岗市: '230400000',
  双鸭山市: '230500000',
  大庆市: '230600000',
  伊春市: '230700000',
  佳木斯市: '230800000',
  七台河市: '230900000',
  牡丹江市: '231000000',
  黑河市: '231100000',
  绥化市: '231200000',
  大兴安岭地区: '232700000',
  南京市: '320100000',
  无锡市: '320200000',
  徐州市: '320300000',
  常州市: '320400000',
  苏州市: '320500000',
  南通市: '320600000',
  连云港市: '320700000',
  淮安市: '320800000',
  盐城市: '320900000',
  扬州市: '321000000',
  镇江市: '321100000',
  泰州市: '321200000',
  宿迁市: '321300000',
  杭州市: '330100000',
  宁波市: '330200000',
  温州市: '330300000',
  嘉兴市: '330400000',
  湖州市: '330500000',
  绍兴市: '330600000',
  金华市: '330700000',
  衢州市: '330800000',
  舟山市: '330900000',
  台州市: '331000000',
  丽水市: '331100000',
  合肥市: '340100000',
  芜湖市: '340200000',
  蚌埠市: '340300000',
  淮南市: '340400000',
  马鞍山市: '340500000',
  淮北市: '340600000',
  铜陵市: '340700000',
  安庆市: '340800000',
  黄山市: '341000000',
  滁州市: '341100000',
  阜阳市: '341200000',
  宿州市: '341300000',
  六安市: '341500000',
  亳州市: '341600000',
  池州市: '341700000',
  宣城市: '341800000',
  福州市: '350100000',
  厦门市: '350200000',
  莆田市: '350300000',
  三明市: '350400000',
  泉州市: '350500000',
  漳州市: '350600000',
  南平市: '350700000',
  龙岩市: '350800000',
  宁德市: '350900000',
  南昌市: '360100000',
  景德镇市: '360200000',
  萍乡市: '360300000',
  九江市: '360400000',
  新余市: '360500000',
  鹰潭市: '360600000',
  赣州市: '360700000',
  吉安市: '360800000',
  宜春市: '360900000',
  抚州市: '361000000',
  上饶市: '361100000',
  济南市: '370100000',
  青岛市: '370200000',
  淄博市: '370300000',
  枣庄市: '370400000',
  东营市: '370500000',
  烟台市: '370600000',
  潍坊市: '370700000',
  济宁市: '370800000',
  泰安市: '370900000',
  威海市: '371000000',
  日照市: '371100000',
  莱芜市: '371200000',
  临沂市: '371300000',
  德州市: '371400000',
  聊城市: '371500000',
  滨州市: '371600000',
  菏泽市: '371700000',
  郑州市: '410100000',
  开封市: '410200000',
  洛阳市: '410300000',
  平顶山市: '410400000',
  安阳市: '410500000',
  鹤壁市: '410600000',
  新乡市: '410700000',
  焦作市: '410800000',
  濮阳市: '410900000',
  许昌市: '411000000',
  漯河市: '411100000',
  三门峡市: '411200000',
  南阳市: '411300000',
  商丘市: '411400000',
  信阳市: '411500000',
  周口市: '411600000',
  驻马店市: '411700000',
  省直辖县级行政区划: '469000000',
  武汉市: '420100000',
  黄石市: '420200000',
  十堰市: '420300000',
  宜昌市: '420500000',
  襄阳市: '420600000',
  鄂州市: '420700000',
  荆门市: '420800000',
  孝感市: '420900000',
  荆州市: '421000000',
  黄冈市: '421100000',
  咸宁市: '421200000',
  随州市: '421300000',
  恩施土家族苗族自治州: '422800000',
  长沙市: '430100000',
  株洲市: '430200000',
  湘潭市: '430300000',
  衡阳市: '430400000',
  邵阳市: '430500000',
  岳阳市: '430600000',
  常德市: '430700000',
  张家界市: '430800000',
  益阳市: '430900000',
  郴州市: '431000000',
  永州市: '431100000',
  怀化市: '431200000',
  娄底市: '431300000',
  湘西土家族苗族自治州: '433100000',
  广州市: '440100000',
  韶关市: '440200000',
  深圳市: '440300000',
  珠海市: '440400000',
  汕头市: '440500000',
  佛山市: '440600000',
  江门市: '440700000',
  湛江市: '440800000',
  茂名市: '440900000',
  肇庆市: '441200000',
  惠州市: '441300000',
  梅州市: '441400000',
  汕尾市: '441500000',
  河源市: '441600000',
  阳江市: '441700000',
  清远市: '441800000',
  东莞市: '441900000',
  中山市: '442000000',
  潮州市: '445100000',
  揭阳市: '445200000',
  云浮市: '445300000',
  南宁市: '450100000',
  柳州市: '450200000',
  桂林市: '450300000',
  梧州市: '450400000',
  北海市: '450500000',
  防城港市: '450600000',
  钦州市: '450700000',
  贵港市: '450800000',
  玉林市: '450900000',
  百色市: '451000000',
  贺州市: '451100000',
  河池市: '451200000',
  来宾市: '451300000',
  崇左市: '451400000',
  海口市: '460100000',
  三亚市: '460200000',
  三沙市: '460300000',
  成都市: '510100000',
  自贡市: '510300000',
  攀枝花市: '510400000',
  泸州市: '510500000',
  德阳市: '510600000',
  绵阳市: '510700000',
  广元市: '510800000',
  遂宁市: '510900000',
  内江市: '511000000',
  乐山市: '511100000',
  南充市: '511300000',
  眉山市: '511400000',
  宜宾市: '511500000',
  广安市: '511600000',
  达州市: '511700000',
  雅安市: '511800000',
  巴中市: '511900000',
  资阳市: '512000000',
  阿坝藏族羌族自治州: '513200000',
  甘孜藏族自治州: '513300000',
  凉山彝族自治州: '513400000',
  贵阳市: '520100000',
  六盘水市: '520200000',
  遵义市: '520300000',
  安顺市: '520400000',
  黔西南布依族苗族自治州: '522300000',
  黔东南苗族侗族自治州: '522600000',
  黔南布依族苗族自治州: '522700000',
  昆明市: '530100000',
  曲靖市: '530300000',
  玉溪市: '530400000',
  保山市: '530500000',
  昭通市: '530600000',
  丽江市: '530700000',
  普洱市: '530800000',
  临沧市: '530900000',
  楚雄彝族自治州: '532300000',
  红河哈尼族彝族自治州: '532500000',
  文山壮族苗族自治州: '532600000',
  西双版纳傣族自治州: '532800000',
  大理白族自治州: '532900000',
  德宏傣族景颇族自治州: '533100000',
  怒江傈僳族自治州: '533300000',
  迪庆藏族自治州: '533400000',
  拉萨市: '540100000',
  昌都地区: '542100000',
  山南地区: '542200000',
  日喀则地区: '542300000',
  那曲地区: '542400000',
  阿里地区: '542500000',
  林芝地区: '542600000',
  西安市: '610100000',
  铜川市: '610200000',
  宝鸡市: '610300000',
  咸阳市: '610400000',
  渭南市: '610500000',
  延安市: '610600000',
  汉中市: '610700000',
  榆林市: '610800000',
  安康市: '610900000',
  商洛市: '611000000',
  兰州市: '620100000',
  嘉峪关市: '620200000',
  金昌市: '620300000',
  白银市: '620400000',
  天水市: '620500000',
  武威市: '620600000',
  张掖市: '620700000',
  平凉市: '620800000',
  酒泉市: '620900000',
  庆阳市: '621000000',
  定西市: '621100000',
  陇南市: '621200000',
  临夏回族自治州: '622900000',
  甘南藏族自治州: '623000000',
  西宁市: '630100000',
  海东地区: '632100000',
  海北藏族自治州: '632200000',
  黄南藏族自治州: '632300000',
  海南藏族自治州: '632500000',
  果洛藏族自治州: '632600000',
  玉树藏族自治州: '632700000',
  海西蒙古族藏族自治州: '632800000',
  银川市: '640100000',
  石嘴山市: '640200000',
  吴忠市: '640300000',
  固原市: '640400000',
  中卫市: '640500000',
  乌鲁木齐市: '650100000',
  克拉玛依市: '650200000',
  吐鲁番地区: '652100000',
  哈密地区: '652200000',
  昌吉回族自治州: '652300000',
  博尔塔拉蒙古自治州: '652700000',
  巴音郭楞蒙古自治州: '652800000',
  阿克苏地区: '652900000',
  克孜勒苏柯尔克孜自治州: '653000000',
  喀什地区: '653100000',
  和田地区: '653200000',
  伊犁哈萨克自治州: '654000000',
  塔城地区: '654200000',
  阿勒泰地区: '654300000',
  自治区直辖县级行政区划: '659000000',
  台湾省: '710000000',
  香港特别行政区: '810100000',
  澳门特别行政区: '820000000'
}

export const MAP_PROVINCES = {
  // 23个省
  台湾: ['taiwan', [120.999792, 23.813893]],
  河北: ['hebei', [115.933822456, 39.1925210525]],
  山西: ['shanxi', [112.7385144, 37.6933615268]],
  辽宁: ['liaoning', [122.07322781, 41.141248023]],
  吉林: ['jilin', [122.840776679, 45.6210862752]],
  黑龙江: ['heilongjiang', [125.02183973, 46.59670902]],
  江苏: ['jiangsu', [119.427777551, 32.9085052546]],
  浙江: ['zhejiang', [120.690634734, 28.002837594]],
  安徽: ['anhui', [117.018638863, 32.6428118237]],
  福建: ['fujian', [118.600362343, 24.901652384]],
  江西: ['jiangxi', [116.360918867, 27.9545451703]],
  山东: ['shandong', [116.600797625, 35.4221216643]],
  河南: ['henan', [112.447524769, 34.6573678177]],
  湖北: ['hubei', [112.241865807, 30.332590523]],
  湖南: ['hunan', [111.614647686, 26.4359716468]],
  广东: ['guangdong', [113.078125341, 22.5751167835]],
  海南: ['hainan', [112.350383075, 16.840062894]],
  四川: ['sichuan', [104.067923463, 30.6799428454]],
  贵州: ['guizhou', [106.931260316, 27.6999613771]],
  云南: ['yunnan', [102.714601139, 25.0491531005]],
  陕西: ['shanxi1', [109.745925744, 36.0794392401]],
  甘肃: ['gansu', [107.644227087, 35.7268007545]],
  青海: ['qinghai', [100.624066094, 36.2843638038]],
  // 5个自治区
  新疆: ['xinjiang', [79.9302386372, 37.1167744927]],
  广西: ['guangxi', [111.30547195, 23.4853946367]],
  内蒙古: ['neimenggu', [111.66035052, 40.8283188731]],
  宁夏: ['ningxia', [106.285267996, 36.0215234807]],
  西藏: ['xizang', [97.18558158, 31.1405756319]],
  // 4个直辖市
  北京: ['beijing', [116.395645038, 39.9299857781]], // 110000000
  天津: ['tianjin', [117.210813092, 39.489299033]], // 120000000
  上海: ['shanghai', [121.487899486, 31.24916171]], // 310000000
  重庆: ['chongqing', [106.530635013, 29.5446061089]],
  // 2个特别行政区
  香港: ['xianggang', [114.146701965, 22.4274312754]],
  澳门: ['aomen', [113.566432335, 22.1950041592]]
}

export const LIU_YU = [
  '西北、西南诸河流域',
  '海滦河流域',
  '辽河流域',
  '东南沿海诸河流域',
  '珠江流域',
  '黑龙江流域',
  '淮河诸河流域',
  '长江流域',
  '黄河流域'
]
